import { List, ListItem, TextLink } from 'darrius';
import { useState } from 'react';
import { triggerEvent } from '../../../utils/triggerEvent';
import { diacriticsTranslation } from '../../../utils/diacriticsTranslation';
import styles from './ProfileMenu.module.scss';

type TProfileMenuItem = {
  title: string;
  link: string;
};

export interface IProfileProps {
  menu: TProfileMenuItem[];
  user?: {
    id?: string;
    requestId?: string;
  };
  internalProfileId?: number;
}

export const ProfileMenu = ({
  menu,
  user,
  internalProfileId,
}: IProfileProps) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleClickedMenuItem = (label: string, index: number) => {
    setActiveIndex(index);

    const diacriticsTranslationRegex = new RegExp(
      `[${Object.keys(diacriticsTranslation).join('')}]`,
      'g'
    );

    const labelWithoutDiacritics = label.replace(
      diacriticsTranslationRegex,
      (char) => {
        return diacriticsTranslation[char] || char;
      }
    );

    const menuLabel = labelWithoutDiacritics.toLowerCase();
    const labelPosition = index + 1;

    if (user && user.requestId) {
      triggerEvent('instant_contact_cli__menu', {
        requestId: user.requestId,
        profileId: user.id,
        menuLabel,
        labelPosition,
      });
    }

    if (internalProfileId) {
      triggerEvent('internal_profile__menu', {
        profileId: internalProfileId,
        menuLabel,
        labelPosition,
      });
    }
  };

  return (
    <div
      className={`profile-menu ${styles['profile-menu']} ${styles['profile-menu--sticky']}`}
      data-testid="profile-menu"
    >
      <div
        className={`profile-menu__container ${styles['profile-menu__container']}`}
      >
        <List
          className={`profile-menu__list ${styles['profile-menu__slider-sm']}`}
        >
          {menu.map((item, index) => (
            <ListItem
              key={item.link}
              className={`profile-menu__list-item ${styles['profile-menu__list-item']}`}
            >
              <TextLink
                url={item.link}
                target="_self"
                className={`profile-menu__link ${styles['profile-menu__link']} ${index === activeIndex ? 'clicked' : ''}`}
                text={item.title}
                onClick={() => handleClickedMenuItem(item.title, index)}
              />
            </ListItem>
          ))}
        </List>
      </div>
    </div>
  );
};
